import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle } from './geoBlockPopup.style';
import { t } from '../../i18n';
import { Button } from '../../tornado/button/button.component';
import { ROUTE_BACK_SIGNAL } from '../../popupContainer/popupContainer.constants';
import { BrandIcon } from '../../tornado/brand-icon/brandIcon.component';

export class GeoBlockPopup extends Lightning.Component {
  static _template() {
    return _merge(getInitialStyle(), {
      FlexContainer: {
        Icon: {
          type: BrandIcon,
        },
        Description: {
          text: {
            text: t('layout.locks.geoBlocked.message'),
          },
        },
        OkButton: {
          type: Button,
          label: t('global.close'),
        },
      },
      passSignals: {
        [ROUTE_BACK_SIGNAL]: true,
      },
    });
  }

  _getFocused() {
    return this.tag('OkButton');
  }

  _handleEnter() {
    return this._handleExitPopup();
  }

  _handleBack() {
    return this._handleExitPopup();
  }

  _handleExitPopup() {
    // TODO check app exit or route back in case if deeplinking will be added
    this.signal(ROUTE_BACK_SIGNAL);

    return true;
  }
}
